import React from 'react';
import clsx from 'clsx';
import { ISearchResult } from '../types';

const SearchResult = ({ body, truncateResults }: ISearchResult) => (
  <span
    className={clsx(
      'tw-py-1',
      { 'tw-line-clamp-3': truncateResults },
    )}
    dangerouslySetInnerHTML={{ __html: `${body}…` }}
  />
);

export { default as ImageModel } from './ImageModel';
export default SearchResult;
